import React from 'react';
import PropTypes from 'prop-types';
import { MediumHeader } from '@narvar/nth-header';

const PickupLocation = ({
  title,
  subtitle,
  address: { street_1: street1, street_2: street2, city, state, zip },
}) => (
  <div>
    <MediumHeader s={{ margin: '1.5rem 0 1rem', fontSize: '1rem' }}>{title}</MediumHeader>
    <p style={{ marginBottom: '1rem', color: '#7a7a7a', fontFamily: 'inherit' }}>{subtitle}</p>
    <address style={{ margin: '1rem auto 1.5rem' }}>
      <div>{street1}</div>
      {street2 && <div>{street2}</div>}
      <div>
        {city}, {state} {zip}
      </div>
    </address>
  </div>
);

PickupLocation.defaultProps = {
  title: 'Pickup Location',
  subtitle: 'This is the original delivery address and cannot be edited.',
};

PickupLocation.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  address: PropTypes.shape({
    street_1: PropTypes.string,
    street_2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
  }).isRequired,
};

export default PickupLocation;
